/* DillySocks — AW26 Launch-Countdown Hero: Countdown-Logik + Klaviyo Early-Access-Formular. */
(function () {
  'use strict';

  var KLAVIYO_REVISION = '2026-07-15';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    n = String(n);
    return n.length < 2 ? '0' + n : n;
  }

  /* Ziel-Datum kommt bereits als fertiger UTC-Unix-Timestamp aus Liquid
     (section.settings.target_date | date: '%s') — kein Zeitzonen-Handling
     im Browser nötig. */
  function initCountdown(root) {
    var el = root.querySelector('[data-ds-aw26-countdown]');
    if (!el) return;
    var epoch = parseInt(el.dataset.targetEpoch, 10);
    if (!epoch || isNaN(epoch)) return;

    var post = root.querySelector('[data-ds-aw26-post]');
    var form = root.querySelector('[data-ds-aw26-form]');
    var live = root.querySelector('[data-ds-aw26-countdown-live]');
    var nums = {
      days: el.querySelector('[data-cd="days"]'),
      hours: el.querySelector('[data-cd="hours"]'),
      minutes: el.querySelector('[data-cd="minutes"]'),
      seconds: el.querySelector('[data-cd="seconds"]')
    };
    var timer = null;
    var lastMinute = null;

    function finish() {
      clearInterval(timer);
      el.hidden = true;
      if (form) form.hidden = true;
      if (post) post.hidden = false;
    }

    function tick() {
      var diff = epoch - Math.floor(Date.now() / 1000);
      if (diff <= 0) {
        finish();
        return;
      }
      var days = Math.floor(diff / 86400);
      var hours = Math.floor((diff % 86400) / 3600);
      var minutes = Math.floor((diff % 3600) / 60);
      var seconds = diff % 60;
      if (nums.days) nums.days.textContent = pad(days);
      if (nums.hours) nums.hours.textContent = pad(hours);
      if (nums.minutes) nums.minutes.textContent = pad(minutes);
      if (nums.seconds) nums.seconds.textContent = pad(seconds);
      /* Screenreader-Ansage nur bei Minutenwechsel, kein Sekunden-Spam. */
      if (live && minutes !== lastMinute) {
        lastMinute = minutes;
        live.textContent = days + ' Tage, ' + hours + ' Stunden, ' + minutes + ' Minuten bis zum Launch';
      }
    }

    function start() {
      clearInterval(timer);
      tick();
      timer = setInterval(tick, 1000);
    }

    start();
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearInterval(timer);
      } else {
        start();
      }
    });
  }

  function initForm(root) {
    var form = root.querySelector('[data-ds-aw26-form]');
    if (!form) return;
    var configEl = root.querySelector('[data-ds-aw26-config]');
    var config = {};
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        config = {};
      }
    }
    if (!config.publicKey || !config.listId) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.classList.contains('is-success')) return;
      var input = form.querySelector('.ds-aw26__form-input');
      var submitBtn = form.querySelector('.ds-aw26__form-submit');
      var email = input ? input.value.trim() : '';
      if (!email) return;
      if (submitBtn) submitBtn.disabled = true;

      /* subscriptions/properties MÜSSEN innerhalb von profile.data.attributes
         verschachtelt sein (Klaviyo-Schema), nicht als Geschwister von "profile"
         eine Ebene höher — sonst wird der Consent von Klaviyo nicht zugeordnet
         und es kommt kein Double-Opt-in-Mail an, obwohl der Request "durchgeht". */
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  },
                  properties: { aw26_early_access: true }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: config.listId }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + config.publicKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (submitBtn) submitBtn.disabled = false;
          /* Bei einem tatsächlich korrekt geschnürten Request antwortet Klaviyo
             bei JEDEM Request mit 202 + leerem Body, unabhängig davon, ob das
             Profil intern angelegt wurde (Anti-Enumeration-Design) — der Status
             beweist also nie eine echte Zustellung, aber ein Nicht-2xx-Status
             (z.B. 400 bei fehlerhaftem Payload-Schema) ist ein echtes Fehlersignal
             und sollte NICHT als Erfolg angezeigt werden. Echte Verifikation der
             tatsächlichen Anmeldung nur über Klaviyo -> Profiles.*/
          if (!response.ok) return;
          form.classList.add('is-success');
          var success = form.querySelector('[data-ds-aw26-success]');
          if (success) success.hidden = false;
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* Beruehrungs-Wechselbild (Sean 02.09.): Auf Touch-Geraeten gibt es kein
     Hover — solange ein Finger auf der Section liegt, zeigt .is-touch das
     Wechselbild (CSS in ds-aw26-hero.liquid), beim Loslassen wieder das
     Standardbild. Nur aktiv, wenn ueberhaupt ein Wechselbild gerendert ist. */
  function initTouchHover(root) {
    if (!root.querySelector('.ds-aw26__media-el--hover')) return;
    root.addEventListener('touchstart', function () {
      root.classList.add('is-touch');
    }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (ev) {
      root.addEventListener(ev, function () {
        root.classList.remove('is-touch');
      }, { passive: true });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ds-aw26]').forEach(function (root) {
      if (root.dataset.dsAw26Ready) return;
      root.dataset.dsAw26Ready = '1';

      initCountdown(root);
      initForm(root);
      initTouchHover(root);

      if (reduceMotion) {
        root.querySelectorAll('video[autoplay]').forEach(function (v) {
          v.pause();
          v.removeAttribute('autoplay');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
